// extracted by mini-css-extract-plugin
export default {"text":"CardCarousel_text__zAbqh","wrapper":"CardCarousel_wrapper__868Mt"};